import { render, staticRenderFns } from "./CheckboxesElement.vue?vue&type=template&id=387738e4&"
import script from "./CheckboxesElement.vue?vue&type=script&lang=js&"
export * from "./CheckboxesElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports